var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaimond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 39.25,
    height: 39.25,
    rx: 19.625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 39.25,
    height: 39.25,
    rx: 19.625,
    stroke: "black",
    strokeWidth: 0.75
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7369 14.2104H13.4212L9.55273 19.1841H15.0791L16.7369 14.2104Z",
    fill: "#BDDDF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4474 19.1841L25.579 14.2104H22.2632L23.9211 19.1841H29.4474Z",
    fill: "#5DADEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9211 19.1843H29.4474L19.5 30.7896L23.9211 19.1843Z",
    fill: "#4289C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0791 19.1843H9.55273L19.5001 30.7896L15.0791 19.1843Z",
    fill: "#8CCAF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.737 14.2104L15.0791 19.1841H23.9212L22.2633 14.2104H16.737Z",
    fill: "#8CCAF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 30.7896L15.0791 19.1843H23.9212L19.5002 30.7896Z",
    fill: "#5DADEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaimond);
export default __webpack_public_path__ + "static/media/daimond.01a14c4ac4193348f2376e4788447f10.svg";
export { ForwardRef as ReactComponent };